<ng-template #previewLandscapeCard let-item="item">
    <div
        class="card-item"
        [ngClass]="showCollectionBoolean ? 'card-highlight' : ''"
        style="box-shadow: var(--shadow-s); background-color: #ffffff; border-radius: var(--radius-medium)"
        (click)="handleCardClick()"
    >
        <div
            class="wrapper-image"
            style="
                position: relative;
                width: 100%;
                padding-bottom: 56.25%;
                background-color: black;
                border-radius: var(--radius-medium);
            "
        >
            <img class="carousal-item-landscape" [src]="getPreviewItemThumbUrl(item)" alt="" />
        </div>
        <div class="wrapper">
            <div style="padding: 10px; height: 60px">
                <div class="ellipsis text-heading-xxs" style="color: black">
                    <!-- Best of crime petrol  -->
                    <!-- <span *ngIf="item.metadata.name">
                        {{ item.metadata.name }}
                    </span>
                    <span *ngIf="item.metadata.title">
                        {{ item.metadata.title }}
                    </span> -->
                    <span>
                        {{
                            item.metadata.name
                                ? item.metadata.name
                                : item.metadata?.title || item.metadata?.data?.title || item.metadata?.data?.song
                        }}
                    </span>
                </div>
                <div class="ellipsis text-body-xxs" style="color: black">
                    <!-- <span *ngIf="item.metadata.language"> {{ item.metadata.language }} | </span> -->
                    <span> {{ item.metadata.category ? item.metadata.category : item.type }} </span>
                    <span *ngIf="item.metadata.provider"> | {{ item.metadata.provider }} </span>
                    <span *ngIf="item.metadata.contentType"> | {{ item.metadata.contentType }} </span>
                </div>
            </div>
            <span *ngIf="isCollection">
                <app-icon
                    *ngIf="!showCollectionBoolean"
                    class="iconLandscape-show"
                    ic="IcChevronDown"
                    size="l"
                    color="var(--color-primary-60)"
                    (click)="showCollectionCard(item)"
                ></app-icon>
                <app-icon
                    *ngIf="showCollectionBoolean"
                    class="iconLandscape-show"
                    ic="IcChevronUp"
                    size="l"
                    color="var(--color-primary-60)"
                    (click)="hideCollectionCard(item)"
                ></app-icon>
            </span>
            <app-icon
                *ngIf="showScreenIconBundle"
                class="iconCircular-screen"
                ic="IcVisible"
                size="m"
                color="var(--color-primary-60)"
                style="--icon-color: var(--color-primary-60); --icon-size: 1.5rem"
                (click)="handleBundleCard(item)"
            ></app-icon>

            <!-- <span>
                <app-icon
                    *ngIf="!showCardBoolean"
                    class="iconLandscape-visible"
                    ic="IcSuccessColored"
                    size="m"
                    (click)="showCard(item)"
                ></app-icon>
                <app-icon
                    *ngIf="showCardBoolean"
                    class="iconLandscape-visible"
                    ic="IcErrorColored"
                    size="m"
                    (click)="removeCard(item)"
                ></app-icon>
            </span> -->
            <app-icon
                class="iconLandscape-calendar"
                ic="IcTime"
                size="m"
                fill="var(--color-primary-60)"
                style="--icon-color: var(--color-primary-60); --icon-size: 1.5rem"
                (click)="handleModalClick()"
            ></app-icon>
            <div class="text-body-xxxs">
                <div class="pop-up-icon">
                    <app-icon ic="IcTime" size="s" fill="var(--color-primary-60)"></app-icon>
                </div>
            </div>
        </div>
    </div>
</ng-template>

<ng-template #previewPortraitCard let-item="item">
    <div
        class="card-item"
        style="box-shadow: var(--shadow-s); background-color: #ffffff; border-radius: var(--radius-medium)"
        (click)="handleCardClick()"
    >
        <div
            class="wrapper-image"
            style="
                position: relative;
                width: 100%;
                padding-bottom: 133.33%;
                background-color: black;
                border-radius: var(--radius-medium);
            "
        >
            <img class="carousal-item-portrait" [src]="getPreviewItemThumbUrl(item)" alt="" />
        </div>
        <div class="wrapper">
            <div style="padding: 10px; height: 60px">
                <div class="ellipsis text-heading-xxs" style="color: black">
                    <!-- Best of crime petrol -->
                    <span>
                        {{
                            item.metadata.name
                                ? item.metadata.name
                                : item.metadata?.title || item.metadata?.data?.title || item.metadata?.data?.song
                        }}
                    </span>
                </div>
                <div class="ellipsis text-body-xxs" style="color: black">
                    <!-- <span *ngIf="item.metadata.language"> {{ item.metadata.language }} | </span>
                    <span *ngIf="item.metadata.contentType"> {{ item.metadata.contentType }} | </span>
                    <span *ngIf="item.metadata.provider">
                        {{ item.metadata.provider }}
                    </span> -->
                    <span> {{ item.metadata.category ? item.metadata.category : item.type }} </span>
                    <span *ngIf="item.metadata.provider"> | {{ item.metadata.provider }} </span>
                    <span *ngIf="item.metadata.contentType"> | {{ item.metadata.contentType }} </span>
                </div>
            </div>
            <span *ngIf="isCollection">
                <app-icon
                    *ngIf="!showCollectionBoolean"
                    class="iconLandscape-show"
                    ic="IcChevronDown"
                    size="l"
                    color="var(--color-primary-60)"
                    (click)="showCollectionCard(item)"
                ></app-icon>
                <app-icon
                    *ngIf="showCollectionBoolean"
                    class="iconLandscape-show"
                    ic="IcChevronUp"
                    size="l"
                    color="var(--color-primary-60)"
                    (click)="hideCollectionCard(item)"
                ></app-icon>
            </span>
            <app-icon
                *ngIf="showScreenIconBundle"
                class="iconCircular-screen"
                ic="IcVisible"
                size="m"
                color="var(--color-primary-60)"
                style="--icon-color: var(--color-primary-60); --icon-size: 1.5rem"
                (click)="handleBundleCard(item)"
            ></app-icon>

            <!-- <span>
                <app-icon
                    *ngIf="!showCardBoolean"
                    class="iconPortrait-visible"
                    ic="IcSuccessColored"
                    size="m"
                    (click)="showCard(item)"
                ></app-icon>
                <app-icon
                    *ngIf="showCardBoolean"
                    class="iconPortrait-visible"
                    ic="IcErrorColored"
                    size="m"
                    (click)="removeCard(item)"
                ></app-icon>
            </span> -->
            <app-icon
                class="iconPortrait-calendar"
                ic="IcTime"
                size="m"
                color="var(--color-primary-60)"
                style="--icon-color: var(--color-primary-60); --icon-size: 1.5rem"
                (click)="handleModalClick()"
            ></app-icon>
            <div class="text-body-xxxs">
                <div class="pop-up-icon">
                    <app-icon ic="IcTime" size="s" fill="var(--color-primary-60)"></app-icon>
                </div>
            </div>
        </div>
    </div>
</ng-template>

<ng-template #previewCircularCard let-item="item">
    <!-- {{item}} -->
    <div
        class="card-item"
        style="box-shadow: var(--shadow-s); background-color: #ffffff; border-radius: var(--radius-medium)"
        (click)="handleCardClick()"
    >
        <div style="margin: 0px 6px">
            <div
                class="wrapper-image"
                style="
                    position: relative;
                    width: 100%;
                    padding-bottom: 100%;
                    border-radius: 50%;
                    background-color: black;
                "
            >
                <img class="carousal-item-circular" [src]="getPreviewItemThumbUrl(item)" alt="" />
            </div>
        </div>
        <div class="wrapper" style="padding-bottom: 20px">
            <div class="wrapper-text" style="padding: 10px; height: 70px">
                <div class="ellipsis text-heading-xxs" style="color: black">
                    <!-- Best of crime petrol -->
                    <span>
                        {{
                            item.metadata.name
                                ? item.metadata.name
                                : item.metadata.title || item.metadata.data.title || item.metadata.data.song
                        }}
                    </span>
                </div>
                <div class="ellipsis text-body-xxs" style="color: black">
                    <!-- <span *ngIf="item.metadata.language"> {{ item.metadata.language }} | </span>
                    <span *ngIf="item.metadata.contentType"> {{ item.metadata.contentType }} | </span>
                    <span *ngIf="item.metadata.provider">
                        {{ item.metadata.provider }}
                    </span> -->
                    <span> {{ item.metadata.category ? item.metadata.category : item.type }} </span>
                    <span *ngIf="item.metadata.provider"> | {{ item.metadata.provider }} </span>
                    <span *ngIf="item.metadata.contentType"> | {{ item.metadata.contentType }} </span>
                </div>
            </div>
            <span *ngIf="isCollection">
                <app-icon
                    *ngIf="!showCollectionBoolean"
                    class="iconLandscape-show"
                    ic="IcChevronDown"
                    size="l"
                    color="var(--color-primary-60)"
                    (click)="showCollectionCard(item)"
                ></app-icon>
                <app-icon
                    *ngIf="showCollectionBoolean"
                    class="iconLandscape-show"
                    ic="IcChevronUp"
                    size="l"
                    color="var(--color-primary-60)"
                    (click)="hideCollectionCard(item)"
                ></app-icon>
            </span>
            <app-icon
                *ngIf="showScreenIconBundle"
                class="iconCircular-screen"
                ic="IcVisible"
                size="m"
                color="var(--color-primary-60)"
                style="--icon-color: var(--color-primary-60); --icon-size: 1.5rem"
                (click)="handleBundleCard(item)"
            ></app-icon>

            <!-- <span>
                <app-icon
                    *ngIf="!showCardBoolean"
                    class="iconCircular-visible"
                    ic="IcSuccessColored"
                    size="m"
                    (click)="showCard(item)"
                ></app-icon>
                <app-icon
                    *ngIf="showCardBoolean"
                    class="iconCircular-visible"
                    ic="IcErrorColored"
                    size="m"
                    (click)="removeCard(item)"
                ></app-icon>
            </span> -->
            <app-icon
                *ngIf="showScreenIcon"
                class="iconCircular-screen"
                ic="IcVisible"
                size="m"
                color="var(--color-primary-60)"
                style="--icon-color: var(--color-primary-60); --icon-size: 1.5rem"
            ></app-icon>
            <app-icon
                class="iconCircular-calendar"
                ic="IcTime"
                size="m"
                color="var(--color-primary-60)"
                style="--icon-color: var(--color-primary-60); --icon-size: 1.5rem"
                (click)="handleModalClick()"
            ></app-icon>
            <div class="text-body-xxxs">
                <div class="pop-up-icon">
                    <app-icon ic="IcTime" size="s" fill="var(--color-primary-60)"></app-icon>
                </div>
            </div>
        </div>
    </div>
</ng-template>

<ng-template #previewSubLandscapeCard let-item="item">
    <div
        class="card-item card-highlight"
        style="box-shadow: var(--shadow-s); background-color: #ffffff; border-radius: var(--radius-medium)"
    >
        <div
            class="wrapper-image"
            style="
                position: relative;
                width: 100%;
                padding-bottom: 56.25%;
                background-color: black;
                border-radius: var(--radius-medium);
            "
        >
            <img class="carousal-item-landscape" [src]="getPreviewItemThumbUrl(item)" alt="" />
        </div>
        <div class="wrapper">
            <div style="padding: 10px; height: 60px">
                <div class="ellipsis text-heading-xxs" style="color: black">
                    <span>
                        {{ item.title ? item.title : item.name }}
                    </span>
                </div>
                <div class="ellipsis text-body-xxs" style="color: black">
                    <!-- <span *ngIf="item.language"> {{ item.language }} | </span> -->
                    <span> {{ item.contentType ? item.contentType : item.category }} </span>
                    <span *ngIf="item.provider"> | {{ item.provider }} </span>
                    <span *ngIf="item.contentType"> | {{ item.contentType }} </span>
                </div>
            </div>
        </div>
    </div>
</ng-template>

<ng-template #previewSubPortraitCard let-item="item">
    <div
        class="card-item"
        style="box-shadow: var(--shadow-s); background-color: #ffffff; border-radius: var(--radius-medium)"
    >
        <div
            class="wrapper-image"
            style="
                position: relative;
                width: 100%;
                padding-bottom: 133.33%;
                background-color: black;
                border-radius: var(--radius-medium);
            "
        >
            <img class="carousal-item-portrait" [src]="getPreviewItemThumbUrl(item)" alt="" />
        </div>
        <div class="wrapper">
            <div style="padding: 10px; height: 60px">
                <div class="ellipsis text-heading-xxs" style="color: black">
                    <span>
                        {{ item.title ? item.title : item.name }}
                    </span>
                </div>
                <div class="ellipsis text-body-xxs" style="color: black">
                    <!-- <span *ngIf="item.language"> {{ item.language }} | </span>
                    <span *ngIf="item.contentType"> {{ item.contentType }} | </span>
                    <span *ngIf="item.provider">
                        {{ item.provider }}
                    </span> -->
                    <span> {{ item.contentType ? item.contentType : item.category }} </span>
                    <span *ngIf="item.provider"> | {{ item.provider }} </span>
                    <span *ngIf="item.contentType"> | {{ item.contentType }} </span>
                </div>
            </div>
        </div>
    </div>
</ng-template>

<ng-template #previewSubCircularCard let-item="item">
    <div
        class="card-item"
        style="box-shadow: var(--shadow-s); background-color: #ffffff; border-radius: var(--radius-medium)"
    >
        <div style="margin: 0px 6px">
            <div
                class="wrapper-image"
                style="
                    position: relative;
                    width: 100%;
                    padding-bottom: 100%;
                    border-radius: 50%;
                    background-color: black;
                "
            >
                <img class="carousal-item-circular" [src]="getPreviewItemThumbUrl(item)" alt="" />
            </div>
        </div>
        <div class="wrapper" style="padding-bottom: 20px">
            <div class="wrapper-text" style="padding: 10px; height: 70px">
                <div class="ellipsis text-heading-xxs" style="color: black">
                    <span>
                        {{ item.title ? item.title : item.name }}
                    </span>
                </div>
                <div class="ellipsis text-body-xxs" style="color: black">
                    <!-- <span *ngIf="item.language"> {{ item.language }} | </span>
                    <span *ngIf="item.contentType"> {{ item.contentType }} | </span>
                    <span *ngIf="item.provider">
                        {{ item.provider }}
                    </span> -->
                    <span> {{ item.contentType ? item.contentType : item.category }} </span>
                    <span *ngIf="item.provider"> | {{ item.provider }} </span>
                    <span *ngIf="item.contentType"> | {{ item.contentType }} </span>
                </div>
            </div>
        </div>
    </div>
</ng-template>

<ng-template #previewPdpLandscapeCard let-item="item">
    <div
        class="card-item card-highlight"
        style="box-shadow: var(--shadow-s); background-color: #ffffff; border-radius: var(--radius-medium)"
    >
        <div
            class="wrapper-image"
            style="
                position: relative;
                width: 100%;
                padding-bottom: 56.25%;
                background-color: black;
                border-radius: var(--radius-medium);
            "
        >
            <img class="carousal-item-landscape" [src]="getPreviewItemThumbUrl(item)" alt="" />
        </div>
        <div class="wrapper">
            <div style="padding: 10px; height: 60px">
                <div class="ellipsis text-heading-xxs" style="color: black">
                    <span>
                        {{ item.title ? item.title : item.name }}
                    </span>
                </div>
                <div class="ellipsis text-body-xxs" style="color: black">
                    <!-- <span *ngIf="item.language"> {{ item.language }} | </span> -->
                    <span> {{ item.contentType ? item.contentType : item.category }} </span>
                    <span *ngIf="item.provider"> | {{ item.provider }} </span>
                    <span *ngIf="item.businessType"> | {{ item.businessType }} </span>
                    <span *ngIf="item.contentType"> | {{ item.contentType }} </span>
                </div>
            </div>
        </div>
    </div>
</ng-template>

<ng-template #previewPdpPortraitCard let-item="item">
    <div
        class="card-item"
        style="box-shadow: var(--shadow-s); background-color: #ffffff; border-radius: var(--radius-medium)"
    >
        <div
            class="wrapper-image"
            style="
                position: relative;
                width: 100%;
                padding-bottom: 133.33%;
                background-color: black;
                border-radius: var(--radius-medium);
            "
        >
            <img class="carousal-item-portrait" [src]="getPreviewItemThumbUrl(item)" alt="" />
        </div>
        <div class="wrapper">
            <div style="padding: 10px; height: 60px">
                <div class="ellipsis text-heading-xxs" style="color: black">
                    <span>
                        {{ item.title ? item.title : item.name }}
                    </span>
                </div>
                <div class="ellipsis text-body-xxs" style="color: black">
                    <!-- <span *ngIf="item.language"> {{ item.language }} | </span>
                    <span *ngIf="item.contentType"> {{ item.contentType }} | </span>
                    <span *ngIf="item.provider">
                        {{ item.provider }}
                    </span> -->
                    <span> {{ item.contentType ? item.contentType : item.category }} </span>
                    <span *ngIf="item.provider"> | {{ item.provider }} </span>
                    <span *ngIf="item.businessType"> | {{ item.businessType }} </span>
                    <span *ngIf="item.contentType"> | {{ item.contentType }} </span>
                </div>
            </div>
        </div>
    </div>
</ng-template>

<ng-template #previewPdpCircularCard let-item="item">
    <div
        class="card-item"
        style="box-shadow: var(--shadow-s); background-color: #ffffff; border-radius: var(--radius-medium)"
    >
        <div style="margin: 0px 6px">
            <div
                class="wrapper-image"
                style="
                    position: relative;
                    width: 100%;
                    padding-bottom: 100%;
                    border-radius: 50%;
                    background-color: black;
                "
            >
                <img class="carousal-item-circular" [src]="getPreviewItemThumbUrl(item)" alt="" />
            </div>
        </div>
        <div class="wrapper" style="padding-bottom: 20px">
            <div class="wrapper-text" style="padding: 10px; height: 70px">
                <div class="ellipsis text-heading-xxs" style="color: black">
                    <span>
                        {{ item.title ? item.title : item.name }}
                    </span>
                </div>
                <div class="ellipsis text-body-xxs" style="color: black">
                    <!-- <span *ngIf="item.language"> {{ item.language }} | </span>
                    <span *ngIf="item.contentType"> {{ item.contentType }} | </span>
                    <span *ngIf="item.provider">
                        {{ item.provider }}
                    </span> -->
                    <span> {{ item.contentType ? item.contentType : item.category }} </span>
                    <span *ngIf="item.provider"> | {{ item.provider }} </span>
                    <span *ngIf="item.businessType"> | {{ item.businessType }} </span>
                    <span *ngIf="item.contentType"> | {{ item.contentType }} </span>
                </div>
            </div>
        </div>
    </div>
</ng-template>

<ng-container *ngIf="orientation == 'Landscape' && cardType == 'previewPage'">
    <ng-container *ngTemplateOutlet="previewLandscapeCard; context: { item: item }"></ng-container>
</ng-container>

<ng-container *ngIf="orientation == 'Portrait' && cardType == 'previewPage'">
    <ng-container *ngTemplateOutlet="previewPortraitCard; context: { item: item }"></ng-container>
</ng-container>

<ng-container *ngIf="orientation == 'Square' && cardType == 'previewPage'">
    <ng-container *ngTemplateOutlet="previewCircularCard; context: { item: item }"></ng-container>
</ng-container>

<ng-container *ngIf="orientation == 'Landscape' && cardType == 'previewSubPage'">
    <ng-container *ngTemplateOutlet="previewSubLandscapeCard; context: { item: item }"></ng-container>
</ng-container>

<ng-container *ngIf="orientation == 'Portrait' && cardType == 'previewSubPage'">
    <ng-container *ngTemplateOutlet="previewSubPortraitCard; context: { item: item }"></ng-container>
</ng-container>

<ng-container *ngIf="orientation == 'Square' && cardType == 'previewSubPage'">
    <ng-container *ngTemplateOutlet="previewSubCircularCard; context: { item: item }"></ng-container>
</ng-container>

<ng-container *ngIf="orientation == 'Landscape' && cardType == 'pdpPage'">
    <ng-container *ngTemplateOutlet="previewPdpLandscapeCard; context: { item: item }"></ng-container>
</ng-container>

<ng-container *ngIf="orientation == 'Portrait' && cardType == 'pdpPage'">
    <ng-container *ngTemplateOutlet="previewPdpPortraitCard; context: { item: item }"></ng-container>
</ng-container>

<ng-container *ngIf="orientation == 'Square' && cardType == 'pdpPage'">
    <ng-container *ngTemplateOutlet="previewPdpCircularCard; context: { item: item }"></ng-container>
</ng-container>
